module.exports = __webpack_public_path__ + "img/print_lipsprint.7d84552.webp";